import React, { ReactNode } from 'react'
import { Flex, ThemeUIStyleObject } from 'theme-ui'

export default function Overlay({
  children,
  sx,
}: {
  children?: ReactNode
  sx?: ThemeUIStyleObject
}): React.ReactElement {
  return (
    <Flex
      data-testid="overlay"
      sx={{
        transition: 'opacity 0.2s ease',
        backgroundColor: ['black', 'eerieBlack80'],
        width: '100%',
        height: '100%',
        position: 'fixed',
        left: '0px',
        top: '0px',
        zIndex: 'zIndex600',
        justifyContent: 'center',
        alignItems: 'center',
        ...sx,
      }}
    >
      {children}
    </Flex>
  )
}
